import ks from "./kalmstromShared4";

export class kStyles{
    public static NameSpace:string = "kStyleSheet";
    public static StyleElement:HTMLStyleElement = document.createElement("style");
    public static Styles:kStyleClass[] = [];
    public static AddStyle = (Title:string ): kStyleClass => {
        let NewkStyle:kStyleClass = new kStyleClass();
        
        if (ks.kErrorMode === true) return NewkStyle;
        try {
            let ExistingStyle:kStyleClass|null = kStyles.GetSTyleByTitle(Title);
            if(ExistingStyle){
                return ExistingStyle;
            }else{
                NewkStyle.Title = Title;
                kStyles.Styles.push(NewkStyle);
            
            }
        } catch (e) {ks.kGlobalErrorHandler(e, "kStyles.AddStyle");}
        return NewkStyle;
    };
    public static GetSTyleByTitle = (Title:string ): kStyleClass |null=> {
        let ExistingStyle:kStyleClass;
        if (ks.kErrorMode === true) return null;
        try {
            for(ExistingStyle of kStyles.Styles){
                if(ExistingStyle.Title === Title){
                    return ExistingStyle;
                }
            }
        } catch (e) {ks.kGlobalErrorHandler(e, "kStyles.GetSTyleByTitle");}
        return null;
    };
    public static Save = (): void => {
        let CurrStyle:kStyleClass;
        if (ks.kErrorMode === true) return;
        try {
            if(kStyles.StyleElement.id!== kStyles.NameSpace){
                kStyles.StyleElement.id = kStyles.NameSpace;
                document.head.appendChild(kStyles.StyleElement);
                window.KDebug.kStyles = kStyles;
            }            

           //if(kStyles.Constructing  === false){
            const Sheet:CSSStyleSheet|null = (kStyles.StyleElement.sheet as CSSStyleSheet);
            if(Sheet){
                for(CurrStyle of kStyles.Styles){
                    if(CurrStyle.Saved === false){
                        let selector:string = "." + CurrStyle.Title;
                        if(CurrStyle.Hover){
                            selector = selector + ":hover";
                        }
                        if(CurrStyle.Active){
                            selector = selector + ":active";
                        }
                        const ruleText:string = `${selector} { ${CurrStyle.Style.cssText} }`;
                        const index:number = Sheet.insertRule(ruleText,Sheet.cssRules.length);
                        const NewRule:CSSRule|null = Sheet.cssRules[index];
                        if(NewRule && (NewRule instanceof CSSStyleRule)){
                            CurrStyle.Style = NewRule.style;
                        }
                        CurrStyle.Saved = true;
                        CurrStyle.New = false;
                    }
                }
            }
        } catch (e) {
        ks.kGlobalErrorHandler(e, "kIcon.AddStyle");
        }
    };
    public static Add = (ClassName:string,CssText:string,Hover:boolean,Active?:boolean):kStyleClass => {
        let NewClass:kStyleClass |null;
        if (ks.kErrorMode === true) return new kStyleClass();
        try {
            NewClass = kStyles.GetSTyleByTitle(ClassName);
            if(NewClass){
                return NewClass;
            }else{
                NewClass = new kStyleClass();
                NewClass.Hover = Hover;
                NewClass.Active = ks.nb(Active);
                NewClass.Title = ClassName;
                NewClass.Style.cssText = CssText;
                kStyles.Styles.push(NewClass);
                return NewClass;
            }
        } catch (e) {ks.kGlobalErrorHandler(e, "kStyles.Add");}
        return new kStyleClass()
    }

    public static AddStyles = (StyleName:string, Stylestring:string): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            const ExistingStyle: HTMLElement | null = document.getElementById(StyleName);
            if (ExistingStyle === null) {
                const Style: HTMLStyleElement = document.createElement('style');
                Style.id = "A3FormEditorStyles";
                Style.innerHTML = Stylestring;
                document.head.appendChild(Style);
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kStyles.AddStyles");
        }

    };

}

export class kStyleClass {
    public Title:string = "";
    public Saved:boolean = false;
    public New:boolean = true;
    public Hover:boolean = false;
    public Active:boolean = false;
    private _FakeElem:HTMLSpanElement = document.createElement("span");
    public Style:CSSStyleDeclaration =this._FakeElem.style;
    public Apply = (Obj:HTMLElement): void => {
        if (ks.kErrorMode === true) return;
        try {
            if(!Obj.classList.contains(this.Title)){
                Obj.classList.add(this.Title);
            }
            if(this.Saved === false){
                kStyles.Save();
            }
        } catch (e) {ks.kGlobalErrorHandler(e, "kStyleClass.Apply");}
    };  
    public RemoveClassName = (Obj:HTMLElement): void => {
        if (ks.kErrorMode === true) return;
        try {
            if(Obj.classList.contains(this.Title)){
                Obj.classList.remove(this.Title);
            }
            if(this.Saved === false){
                kStyles.Save();
            }
        } catch (e) {ks.kGlobalErrorHandler(e, "kStyleClass.RemoveClassName");}
    };  
    
}

